import { webApi } from "../../../../core/http/httpThunks";
import { SecurityValuationApiResponse } from "../types";

export const getSecurityValuationApi = (userId: string, symbol: string, endpoint: string) => {
 // console.log("Poziva se getTradeApi sa:", { userId, divid });

  return webApi<SecurityValuationApiResponse>({
    method: "GET",
    url: "reporting/getsecurityinfo",
    params: {
      userId,
      symbol,
      endpoint
    },
  });
};

export default getSecurityValuationApi;
